import React from "react";

function Footer() {
  return (
    <footer className="bg-gradient-to-r from-gray-700 to-gray-900 text-white py-8">
      <div className="container mx-auto grid grid-cols-1 md:grid-cols-3 gap-8">
        <div>
          <h2 className="text-lg font-bold mb-4">Quick Links</h2>
          <ul className="space-y-2">
            <li>
              <a
                href="#/"
                className="hover:text-yellow-400 transition duration-300"
              >
                Home
              </a>
            </li>
            <li>
              <a
                href="#/services"
                className="hover:text-yellow-400 transition duration-300"
              >
                Services
              </a>
            </li>
            <li>
              <a
                href="#/about"
                className="hover:text-yellow-400 transition duration-300"
              >
                About
              </a>
            </li>
            <li>
              <a
                href="#/contact"
                className="hover:text-yellow-400 transition duration-300"
              >
                Contact
              </a>
            </li>
            <li>
              <a
                href="#/testimonials"
                className="hover:text-yellow-400 transition duration-300"
              >
                Testimonials
              </a>
            </li>
            <li>
              <a
                href="#/portfolio"
                className="hover:text-yellow-400 transition duration-300"
              >
                Portfolio
              </a>
            </li>
          </ul>
        </div>

        {/* Contact Information */}
        <div>
          <h2 className="text-lg font-bold mb-4">Contact Us</h2>
          <p>Street 69 BT</p>
          <p>
            Tnaot Chrum Village, Sang Kat Beong Tumpun, Khan Mean Chey, Phnom
            Penh
          </p>
          <p>Email: contact@myservice.com</p>
          <p>Phone: (855) 8698-1118</p>
        </div>

        {/* Social Media Links */}
        <div>
          <h2 className="text-lg font-bold mb-4">Follow Us</h2>
          <div className="flex space-x-4">
            <a
              href="https://www.facebook.com"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-yellow-400 transition duration-300"
            >
              <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
                <path d="M22.675 0h-21.35c-1.097 0-1.978.883-1.978 1.977v21.046c0 1.093.881 1.977 1.978 1.977h11.313v-9.184h-3.105v-3.579h3.105v-2.635c0-3.1 1.895-4.787 4.66-4.787 1.325 0 2.463.099 2.793.143v3.239h-1.916c-1.504 0-1.793.714-1.793 1.763v2.31h3.586l-.467 3.579h-3.119v9.184h6.116c1.094 0 1.978-.883 1.978-1.977v-21.046c0-1.094-.883-1.977-1.978-1.977z" />
              </svg>
            </a>
            <a
              href="https://www.twitter.com"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-yellow-400 transition duration-300"
            >
              <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
                <path d="M24 4.557a9.83 9.83 0 0 1-2.828.775 4.932 4.932 0 0 0 2.165-2.724 9.864 9.864 0 0 1-3.127 1.195 4.917 4.917 0 0 0-8.38 4.482 13.945 13.945 0 0 1-10.125-5.144 4.917 4.917 0 0 0 1.523 6.573 4.901 4.901 0 0 1-2.228-.616c-.053 2.28 1.581 4.415 3.949 4.89a4.934 4.934 0 0 1-2.224.085 4.927 4.927 0 0 0 4.6 3.419 9.867 9.867 0 0 1-6.102 2.104c-.396 0-.787-.023-1.175-.068a13.945 13.945 0 0 0 7.548 2.213c9.057 0 14.01-7.507 14.01-14.01 0-.213-.004-.426-.013-.637a10.004 10.004 0 0 0 2.46-2.548z" />
              </svg>
            </a>
            <a
              href="https://www.linkedin.com"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-yellow-400 transition duration-300"
            >
              <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
                <path d="M22.23 0h-20.46c-.975 0-1.77.797-1.77 1.77v20.459c0 .973.795 1.77 1.77 1.77h20.459c.974 0 1.771-.797 1.771-1.77v-20.459c0-.973-.797-1.77-1.771-1.77zm-14.632 20.452h-3.772v-12.097h3.772v12.097zm-1.879-13.831c-1.212 0-2.196-.985-2.196-2.196 0-1.214.984-2.197 2.196-2.197 1.213 0 2.197.983 2.197 2.197 0 1.212-.984 2.196-2.197 2.196zm15.251 13.831h-3.772v-6.571c0-1.566-.03-3.586-2.188-3.586-2.189 0-2.524 1.708-2.524 3.472v6.684h-3.772v-12.097h3.624v1.649h.052c.504-.952 1.734-1.951 3.569-1.951 3.814 0 4.521 2.51 4.521 5.774v6.625z" />
              </svg>
            </a>
          </div>
        </div>
      </div>
      <div className="mt-8 text-center">
        <p>
          &copy; {new Date().getFullYear()} InnovateService. All rights
          reserved.
        </p>
      </div>
    </footer>
  );
}

export default Footer;
